import { ApolloError } from "@apollo/client";

import Sentry from "../../sentry";
import {
  CustomerPrincipal,
  useWhoAmIQuery,
  Maybe,
} from "../../generated/customer/schema.graphql";
import { GraphQLError } from "graphql";
import { isBrowserSupported } from "../../components/UnsupportedBrowser";

const UNAUTHORISED_ERROR_CODES =
  /((unauthorised)|(unauthorized)|(unauthenticated)|(invalid(.*)authentication)|(token(.*)no(.*)valid)|(access(.*)denied))/;

const UNAUTHORISED_STATUS_CODES = ["401", "403"];

interface UseWhoAmIResponse {
  whoAmI:
    | Maybe<Pick<CustomerPrincipal, "accountID" | "accountNumber">>
    | undefined;
  hasUnauthorisedError: boolean;
  loading: boolean;
}

export const useWhoAmI = (skip = false): UseWhoAmIResponse => {
  const { data, error, loading } = useWhoAmIQuery({
    skip,
    onError: (e: ApolloError) => {
      if (isBrowserSupported()) {
        Sentry.getCurrentScope()
          .setTransactionName("useWhoAmIQuery")
          .captureException(e);
      }
    },
  });

  const isUnauthorised: boolean | undefined =
    error?.graphQLErrors.some(
      (err: GraphQLError) =>
        UNAUTHORISED_ERROR_CODES.test(
          (err.extensions?.code as string)?.toLowerCase()
        ) || UNAUTHORISED_ERROR_CODES.test(err.message)
    ) ||
    UNAUTHORISED_STATUS_CODES.some((code) => error?.message.includes(code));

  return {
    whoAmI: data?.whoAmI?.principal?.customer,
    hasUnauthorisedError: isUnauthorised ?? false,
    loading: loading,
  };
};
